module.exports = {
	"ha": "bc",
	"id": 1.6,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2021 Q1–2022 Q4",
		"lastYear": "2022",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 740,
			"height": 440,
			"marginLeft": 140,
			"marginRight": 170,
			"marginBottom": 120,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "line"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 140px;\">Figure 1.6</span>                 <span style=\"display: table-cell;\">HIV Test Episodes for Non-prenatal Females in BC by Health Authority <sup style=\"font-size: 10px;\">1</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {}
				}
			}
		},
		"xAxis": [
			{
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"offset": 10,
				"labels": {
					"rotation": 0,
					"y": 24
				},
				"categories": [
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2",
					"Q3",
					"Q4",
					"Q1",
					"Q2"
				]
			},
			{
				"linkedTo": 0,
				"startOnTick": true,
				"endOnTick": true,
				"tickmarkPlacement": "on",
				"lineWidth": 0,
				"tickWidth": 0,
				"gridLineWidth": 1,
				"gridLineColor": "#ffffff",
				"offset": 28,
				"labels": {
					"rotation": 0
				},
				"categories": [
					"2017",
					"2017",
					"2018",
					"2018",
					"2018",
					"2018",
					"2019",
					"2019",
					"2019",
					"2019",
					"2020",
					"2020",
					"2020",
					"2020",
					"2021",
					"2021",
					"2021",
					"2021",
					"2022",
					"2022"
				],
				"tickPositions": [
					0,
					2,
					6,
					10,
					14,
					18
				]
			}
		],
		"yAxis": [
			{
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickWidth": 1,
				"tickInterval": 2,
				"gridLineWidth": 0,
				"offset": 10,
				"title": {
					"text": null
				},
				"labels": {
					"format": "{value}"
				}
			},
			{
				"linkedTo": 0,
				"lineColor": "red",
				"lineWidth": 0,
				"tickColor": "red",
				"tickWidth": 0,
				"gridLineWidth": 0,
				"offset": 0,
				"labels": {
					"enabled": false
				},
				"title": {
					"text": "# HIV Test Episodes<br>(thousands)",
					"reserveSpace": false,
					"x": -130
				}
			}
		],
		"series": [
			{
				"name": "Fraser Health",
				"pointPlacement": "on",
				"color": "#0076a3",
				"dashStyle": "Solid",
				"data": [
					8.793,
					8.692,
					9.458,
					9.757,
					9.209,
					8.642,
					9.106,
					9.565,
					10.078,
					10.039,
					8.829,
					6.009,
					8.497,
					8.132,
					8.464,
					8.515,
					8.486,
					8.58,
					8.513,
					{
						"y": 9.058,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#0076a3",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Fraser Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Interior Health",
				"pointPlacement": "on",
				"color": "#9d0140",
				"dashStyle": "Solid",
				"data": [
					4.664,
					4.766,
					4.774,
					4.929,
					4.715,
					6.699,
					12.172,
					12.126,
					12.563,
					12.04,
					11.202,
					9,
					11.879,
					11.236,
					11.051,
					11.999,
					11.96,
					10.878,
					6.655,
					{
						"y": 4.357,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#9d0140",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Interior Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Northern Health",
				"pointPlacement": "on",
				"color": "#ab9f01",
				"dashStyle": "Solid",
				"data": [
					1.706,
					1.664,
					1.91,
					2.076,
					1.829,
					1.777,
					2.037,
					1.981,
					1.885,
					1.786,
					1.65,
					1.032,
					1.498,
					1.498,
					1.497,
					1.613,
					1.453,
					1.681,
					1.738,
					{
						"y": 1.854,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#ab9f01",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Northern Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Coastal Health",
				"pointPlacement": "on",
				"color": "#2b7025",
				"dashStyle": "Solid",
				"data": [
					21.221,
					19.989,
					21.453,
					22.084,
					21.776,
					21.213,
					22.59,
					23.181,
					23.906,
					23.155,
					20.852,
					14.266,
					20.223,
					20.001,
					21.407,
					21.614,
					20.323,
					19.467,
					19.133,
					{
						"y": 20.528,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#2b7025",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Coastal Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			},
			{
				"name": "Vancouver Island Health",
				"pointPlacement": "on",
				"color": "#560054",
				"dashStyle": "Solid",
				"data": [
					3.315,
					3.373,
					3.649,
					3.55,
					3.728,
					3.82,
					3.848,
					3.77,
					4.047,
					3.936,
					3.502,
					2.104,
					2.94,
					3.128,
					3.208,
					2.88,
					2.892,
					2.64,
					2.716,
					{
						"y": 2.929,
						"dataLabels": {
							"enabled": true,
							"backgroundColor": "transparent",
							"padding": 0,
							"allowOverlap": true,
							"crop": false,
							"overflow": "none",
							"align": "left",
							"y": 6,
							"style": {
								"color": "#560054",
								"fontSize": "12px",
								"fontWeight": "normal"
							},
							"format": "<span style=\"padding-left: 5px;\">Vancouver Island Health</span>",
							"useHTML": true
						}
					}
				],
				"table": {
					"visible": true,
					"decimalPoint": 1
				}
			}
		]
	},
	"callback": "C:\\git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_1_6.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_1_6.json
// module id = 152
// module chunks = 0